document.documentElement.dataset.analyticsRelease = '2026-09-24';
